import { localStorageInstance } from '@gem/modules/storage';

const KEY_NAME = 'language';

export const set = (language: string): void => {
  return localStorageInstance.setItem(KEY_NAME, language);
};

export const get = (): string | null => {
  const data = localStorageInstance.getItem(KEY_NAME);

  if (data) {
    return data;
  }

  return null;
};

export const remove = (): void => {
  return localStorageInstance.removeItem(KEY_NAME);
};
